import { Helmet } from 'react-helmet-async';
import ScorecardTimeline from './ScorecardTimeline';

export default function DeveloperScorecard() {
  return (
    <>
      <Helmet>
        <title>Team Scorecard</title>
      </Helmet>
      <ScorecardTimeline />
    </>
  );
}
